var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3611 9.0765C10.0927 9.35545 9.65735 9.35545 9.38886 9.0765L7.125 6.72444L4.86114 9.0765C4.59265 9.35545 4.15735 9.35545 3.88886 9.0765C3.62038 8.79756 3.62038 8.3453 3.88886 8.06635L6.63886 5.20921C6.90735 4.93026 7.34265 4.93026 7.61114 5.20921L10.3611 8.06635C10.6296 8.3453 10.6296 8.79756 10.3611 9.0765Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.393d5075f974848d85c5b59f78e077b1.svg";
export { ForwardRef as ReactComponent };